import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import {styled} from '@mui/system';

import FormButton from '../component/atoms/FormButton';
import {validatePassword} from '../helpers/validate';
import {concatUrl} from '../helpers/url';
import {postCall} from '../helpers/request';
import GlobalContext from '../helpers/context';


const StyledChangePasswordForm = styled(Paper)(({ theme }) =>({
    paddingLeft: theme.custom.paper.side_space,
    paddingRight: theme.custom.paper.side_space,
    paddingTop: theme.custom.paper.top_space,
    paddingBottom: theme.custom.paper.bottom_space,
    marginTop: 30,
    marginBottom: 30
}));


const StyledFormControl = styled(FormControl)({
    minWidth: 200,
    marginBottom: 30
});

const StyledErrorMessage = styled(Typography)(({ theme }) =>({
    color: theme.custom.color.error,
    fontWeight: theme.custom.font.bold,
    marginTop: 5,
    marginLeft: 15
}));


class ChangePasswordForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            old_password: '',
            password: '',
            password_conf: '',
            form_errors: {}
        };

        this.form_data = {};

        this.change_password_url = concatUrl(window.ROOT_URL, 'api', 'user', 'change_password');
    }

    componentDidMount(){
        this.context.checkUserAccess();
        this.props.updatedCallback();
    }

    componentDidUpdate(){
        this.props.updatedCallback();
    }

    formValidated = () => {
        let form_errors = {
            'old_password': this.state.old_password.length === 0 ? 'Please enter the current password' : '',
            // check the password only in case it was updated
            'password': validatePassword(this.state.password, this.state.password_conf),
        };
        this.form_data = {
            old_password: this.state.old_password,
            password: this.state.password,
        };

        this.setState({form_errors: form_errors});
        let form_is_valid = true;

        /*eslint-disable no-unused-vars */
        for (const key in form_errors){
            if (form_errors[key]){
                form_is_valid = false;
                break;
            }
        }
        /*eslint-enabled no-unused-vars */

        return form_is_valid;
    };


    // +++ save password +++++++++++++++++++++++++++++++++++++++++++++++

    savePasswordFailed = () => {
        this.context.displayGlobalError('Backend service failure: Could not save the new password.');
    };

    savePasswordDone = (data) => {
        if (data && data.form_errors){
            this.setState({form_errors: data.form_errors});
        }else {
            window.history.back();
            this.context.displayGlobalInfo('Password changed successfully.');
        }
    };

    savePassword = () => {
        if (this.formValidated()){
            postCall(this.change_password_url, this.form_data, this.savePasswordDone, this.savePasswordFailed);
        }
    };

    showErrorMessage = (key) => {
        if (key in this.state.form_errors && this.state.form_errors[key]) {
            return (
                <StyledErrorMessage data-bt={`error_${key}`}>
                    {this.state.form_errors[key]}
                </StyledErrorMessage>
            );
        }
    };

    errorMode = (key) => {
        return key in this.state.form_errors && this.state.form_errors[key] !== null;
    };

    render() {
        return (
            <GlobalContext.Consumer>{() => (
                <form>
                    <StyledChangePasswordForm data-bt="change_password">
                        <Grid container spacing={5}>
                            <Grid size={6}>
                                <StyledFormControl fullWidth={true}>
                                    <TextField
                                        required
                                        error={this.errorMode('old_password')}
                                        variant="outlined"
                                        id="old_password"
                                        type="password"
                                        autoComplete="old-password"
                                        label="Current password"
                                        slotProps={{ htmlInput: {'data-bt': 'old_password'} }}
                                        value={this.state.old_password}
                                        onChange={(event) => {
                                            this.setState({old_password: event.target.value});
                                        }}
                                    />
                                    {this.showErrorMessage('old_password')}
                                </StyledFormControl>
                                <StyledFormControl fullWidth={true}>
                                    <TextField
                                        required
                                        error={this.errorMode('password')}
                                        variant="outlined"
                                        id="password"
                                        type="password"
                                        autoComplete="new-password"
                                        label="New password"
                                        slotProps={{ htmlInput: {'data-bt': 'password'} }}
                                        value={this.state.password}
                                        onChange={(event) => {
                                            this.setState({password: event.target.value});
                                        }}
                                    />
                                    {this.showErrorMessage('password')}
                                </StyledFormControl>
                                <StyledFormControl fullWidth={true}>
                                    <TextField
                                        required
                                        error={this.errorMode('password')}
                                        variant="outlined"
                                        id="password_conf"
                                        type="password"
                                        autoComplete="off"
                                        label="Password confirmation"
                                        slotProps={{ htmlInput: {'data-bt': 'password_conf'} }}
                                        value={this.state.password_conf}
                                        onChange={(event) => {
                                            this.setState({password_conf: event.target.value});
                                        }}
                                    />
                                </StyledFormControl>
                                <FormButton text="Save" dataBt="save_button" actionCallback={this.savePassword} />
                                <FormButton text="Cancel" actionCallback={()=>{window.history.back()}} />
                            </Grid>
                        </Grid>
                    </StyledChangePasswordForm>
                </form>
            )}
            </GlobalContext.Consumer>
        );
    }
}

ChangePasswordForm.contextType = GlobalContext;

ChangePasswordForm.propTypes = {
    updatedCallback: PropTypes.func
};

export default ChangePasswordForm;
